import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Text, breakpoints, colors } from '@soluto-private/mx-asurion-ui-react';

import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';

import { ReactComponent as FastRepairSvg } from './assets/fast_repair.svg';
import { ReactComponent as HealthCheckSvg } from './assets/health_check.svg';
import { ReactComponent as MedallionSvg } from './assets/medallion.svg';
import { IconWrapper } from './components/IconWrapper';
import { TextWrapper } from './components/TextWrapper';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 27px;
  text-align: start;

  ${breakpoints.lg} {
    gap: 34px;
  }
`;

const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${breakpoints.lg} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 33px 0;
  }
`;

const DetailsWrapperRow = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: row;

  ${breakpoints.lg} {
    display: flex;
    flex-direction: column;
    max-width: 189px;
  }

  ${breakpoints.xl} {
    max-width: 220px;
  }
`;

const TEXT = TranslationEntries.Repairs.WhatHappensNext;

export const WhatHappensNext = forwardRef<HTMLDivElement>((_, fRef) => {
  const { t } = useTranslation();
  return (
    <Container data-testid="what-happens-next" ref={fRef}>
      <Text
        as="h2"
        color={colors.black}
        data-testid="what-happens-next-title"
        size={3}
        weight="base"
      >
        {t(TEXT.Title)}
      </Text>
      <DetailsWrapper>
        <DetailsWrapperRow>
          <IconWrapper>
            <HealthCheckSvg />
          </IconWrapper>
          <TextWrapper
            description={t(TEXT.Diagnostics.Description)}
            title={t(TEXT.Diagnostics.Title)}
          ></TextWrapper>
        </DetailsWrapperRow>
        <DetailsWrapperRow>
          <IconWrapper>
            <FastRepairSvg />
          </IconWrapper>
          <TextWrapper
            description={t(TEXT.FastRepairs.Description)}
            title={t(TEXT.FastRepairs.Title)}
          ></TextWrapper>
        </DetailsWrapperRow>
        <DetailsWrapperRow>
          <IconWrapper>
            <MedallionSvg />
          </IconWrapper>
          <TextWrapper
            description={t(TEXT.Warranty.Description)}
            title={t(TEXT.Warranty.Title)}
          ></TextWrapper>
        </DetailsWrapperRow>
      </DetailsWrapper>
    </Container>
  );
});
